export const RECOMMENDATIONS_POOL_LIMIT = 50;
export const BREAKING_NEWS_COUNT = 4;
export const TRENDING_STORIES_COUNT = 5;
export const RELATED_NEWS_COUNT = 4;

export function normalizeNewsSlug(slug) {
	if (!slug) return "";
	return String(slug)
		.replace(/^\/+|\/+$/g, "")
		.replace(/\.json$/, "")
		.trim()
		.toLowerCase();
}

export function dedupeNewsBySlug(items) {
	const seen = new Set();
	const out = [];

	for (const item of items || []) {
		const slug = normalizeNewsSlug(item?.slug);
		if (!slug || seen.has(slug)) continue;
		seen.add(slug);
		out.push(item);
	}

	return out;
}

export function shuffleNewsRecommendations(items) {
	const copy = [...(items || [])];

	for (let i = copy.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[copy[i], copy[j]] = [copy[j], copy[i]];
	}

	return copy;
}

export function filterNewsRecommendations(items, excludeSlugs = []) {
	const exclude = new Set(
		(Array.isArray(excludeSlugs) ? excludeSlugs : [excludeSlugs])
			.map(normalizeNewsSlug)
			.filter(Boolean)
	);

	return dedupeNewsBySlug(items).filter(
		(item) => !exclude.has(normalizeNewsSlug(item.slug))
	);
}

export function prepareNewsRecommendationsPool(items, currentSlug) {
	return shuffleNewsRecommendations(
		filterNewsRecommendations(items, currentSlug)
	);
}

export function pickNewsRecommendations(
	items,
	{ excludeSlugs = [], offset = 0, limit = 4 } = {}
) {
	const filtered = filterNewsRecommendations(items, excludeSlugs);
	return filtered.slice(offset, offset + limit);
}
